
import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";

export const ShopLoadingState = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-semibold mb-4">Apparel Shop</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="border rounded-md p-4">
            <Skeleton className="w-full h-40 rounded-md bg-muted" />
            <div className="mt-2 space-y-2">
              <Skeleton className="h-4 w-3/4 bg-muted" />
              <Skeleton className="h-4 w-1/2 bg-muted" />
              <Skeleton className="h-4 w-1/4 bg-muted" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

